import { render, staticRenderFns } from "./OrganizationPacketCreatorLibraryGuard.vue?vue&type=template&id=2ef7e7ac&"
import script from "./OrganizationPacketCreatorLibraryGuard.vue?vue&type=script&lang=ts&"
export * from "./OrganizationPacketCreatorLibraryGuard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports